import { fmtShort } from "../hooks/useRounds";

// Six-node season timeline. Flat: one solid line, solid dots. The MAIN round's
// dot pulses (the live round on event day, else the next one - client, 2026-10-19). Colour is inherited from the
// band via CSS custom properties (black on yellow, yellow on black).
export function RoundsTimeline({ rounds, selected, onSelect, testidPrefix = "round-node" }) {
  const completed = rounds.filter((r) => r.status === "completed" || r.status === "live").length;
  const denom = Math.max(1, rounds.length - 1);
  const pct = Math.max(0, Math.min(1, (completed - 1) / denom)) * 100;
  return (
    <div className="gm-tl" role="tablist" aria-label="Season rounds" data-testid="rounds-timeline">
      {/* Progress as a CSS var: width on the horizontal (desktop) bar, height on the vertical (phone) bar. */}
      <div className="gm-tl__line" aria-hidden="true" style={{ "--tl-pct": `${pct}%` }}><i /></div>
      {rounds.map((r) => (
        <button
          key={r.n}
          type="button"
          role="tab"
          aria-selected={r.n === selected}
          className={`gm-tl__node is-${r.status} ${r.is_main ? "is-main" : ""} ${r.n === selected ? "is-sel" : ""}`}
          onClick={() => onSelect(r.n)}
          data-testid={`${testidPrefix}-${r.n}`}
        >
          <i className="gm-tl__dot" aria-hidden="true" />
          <span className="tech-num gm-tl__rd">Round {r.n}</span>
          <span className="gm-tl__c" data-layout={r.layout || ""}>{r.venue || r.circuit}</span>
          {r.layout && <span className="gm-tl__l">{r.layout}</span>}
          <span className="tech-num gm-tl__d">{fmtShort(r.date)}</span>
        </button>
      ))}
    </div>
  );
}
